import Vue from 'vue';
import Router from 'vue-router';
import weChatUtil from './utils/weChatUtil';
import {TOKEN_KEY} from "./config/constant";
import book from './views/driving/book';
import Auth from './views/auth';
import inspectionBook from './views/inspection/book';
import settlement from './views/settlement';
import LingBiaoIndex from './views/lingbiao/index';
Vue.use(Router);

const router =  new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/auth',
      component: Auth,
      meta: {
        title: "微信认证授权",
        needJsapi: true
      }
    },
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/pages/index/index',
      redirect: '/index'
    },
    {
      path:'/index',
      component:() => import('./views/index.vue'),
      meta:{
        title:'车易盟',
        needJsapi: true
      }
    },
    {
      path:'/concat',
      component:() => import('./views/concat.vue'),
      meta:{
        title:'车易盟',
        needJsapi: true
      }
    },
    {
      path:'/my',
      component:() => import('./views/my/center.vue'),
      meta:{
        title:'车易盟-我的',
        needJsapi: true
      }
    },
    {
      path:'/create/car',
      component: () => import("./views/my/car/addOrUpdate.vue"),
      meta:{
        title:'车易盟-添加爱车',
        needJsapi: true
      }
    },
    {
      path:'/update/car/:id',
      component: () => import("./views/my/car/addOrUpdate.vue"),
      meta:{
        title:'车易盟-编辑爱车',
        needJsapi: true
      }
    },
    {
      path:'/car/update/:id',
      component:() => import('./views/my/car/addOrUpdate.vue'),
      meta:{
        title:'车易盟-修改爱车',
        needJsapi: true
      }
    },
    {
      path:'/order/list',
      component:() => import('./views/my/order/list.vue'),
      meta:{
        title:'车易盟-我的订单',
        needJsapi: true
      }
    },{
      path:'/order/:orderNo',
      component:() => import('./views/my/order/detail.vue'),
      meta:{
        title:'车易盟-我的订单',
        needJsapi: true
      }
    },
    {
      path:'/inspection/book/:merchantId',
      component:inspectionBook,
      meta:{
        title:'车易盟-预约年检',
        needJsapi: true
      }
    },
    {
      path:'/lingbiao/weizhang',
      component:() => import('./views/lingbiao/weizhang.vue'),
      meta:{
        title:'车易盟-违章查询',
        needJsapi: true
      }
    },
    {
      path:'/lingbiao',
      component:LingBiaoIndex,
      meta:{
        title:'车易盟-申领电子标',
        needJsapi: true
      }
    },
    {
      path:'/lingbiao/doc',
      component:() => import('./views/lingbiao/doc.vue'),
      meta:{
        title:'车易盟-6年免检领取电子标',
        needJsapi: true
      }
    },
    {
      path:'/cpic/lingbiao/doc',
      component:() => import('./views/cpic/lingbiaoDoc.vue'),
      meta:{
        title:'太平洋保险-爱车在线免检',
        needJsapi: true
      }
    },
    {
      path:'/nearby',
      component:() => import('./views/outlet/nearby.vue'),
      meta:{
        title:'车易盟-附近网点',
        needJsapi: true
      }
    },{
      path:'/outlet/detail/:id',
      component:() => import('./views/outlet/detail.vue'),
      meta:{
        title:'车易盟-网点详情',
        needJsapi: true
      }
    },{
      path:'/bind/user',
      component:() => import('./views/my/bind.vue'),
      meta:{
        title:'车易盟-绑定手机号',
        needJsapi:true
      }
    },{
      path:'/notice',
      component:() => import('./views/notice.vue'),
      meta:{
        title:'车易盟-预约须知',
        needJsapi:true
      }
    }, {
      path:'/driving/book',
      component:book,
      meta:{
        title:'车易盟-预约代驾车检',
        needJsapi:true
      }
    }, {
      path:'/settlement',
      component:settlement,
      meta:{
        title:'车易盟-结算',
        needJsapi:true
      }
    },{
      path:'/my/car',
      component:() => import('./views/my/car/list.vue'),
      meta:{
        title:'车易盟-我的爱车',
        needJsapi:true
      }
    },{
      path:'/cic/order/sign/validate',
      component:() => import('./views/my/order/validate.vue'),
      meta:{
        title:'车易盟-验证信息',
        needJsapi:true
      }
    },{
      path:'/cic/order/choose/store',
      component:() => import('./views/my/order/store.vue'),
      meta:{
        title:'车易盟-选择网点',
        needJsapi:true
      }
    },
    {
      path:'/cic/order/store/:storeId/detail',
      component:() => import('./views/my/order/storeDetail.vue'),
      meta:{
        title:'车易盟-网点详情',
        needJsapi:true
      }
    }
  ]
});

router.beforeEach((to, from, next) =>{



  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }


  if(to.path.indexOf('cpic') < 0){
    const token = localStorage.getItem(TOKEN_KEY);
    if (to.path !== '/auth') {
      localStorage.setItem('beforeUrl', to.fullPath);

      if (!token) {
        const redirectUrl = weChatUtil.redirectAuth();
        window.location.href = redirectUrl;
        return false;
      }
    }
  }

  if(weChatUtil.isWeChatBrowser()){
    router.app.$http.post("/wechat/jsapi", window.location.origin + to.fullPath, {headers: {'Content-Type': 'text/plain'}}).then(resp => {
      if (resp.success) {
        const sign = resp.data;
        router.app.$wechat.config({
          debug: false,
          appId: sign.appId,
          timestamp: sign.timestamp,
          nonceStr: sign.nonceStr,
          signature: sign.signature,
          jsApiList: [
            'getLocation', 'openLocation', 'onMenuShareTimeline',
            'onMenuShareAppMessage', 'chooseWXPay', 'showMenuItems', 'hideMenuItems',
            'updateAppMessageShareData', 'updateTimelineShareData'
          ]
        });
      }
    }).catch(error => {
      console.log(error);
    }).finally(() => {

      if(['book','settlement','nearby', 'my','order'].some(item => to.path.indexOf(item) != -1)){
        router.app.$wechat.ready(() => {
          router.app.$wechat.hideMenuItems({
            menuList:[
              'menuItem:share:appMessage',
              "menuItem:share:timeline",
              "menuItem:share:qq",
              "menuItem:share:weiboApp",
              "menuItem:favorite",
              "menuItem:share:facebook",
              'menuItem:share:QZone',
              "menuItem:copyUrl",
              "menuItem:originPage",
              "menuItem:openWithSafari",
              "menuItem:share:email"
            ]
          })
        })
      }
      next();
    });
  } else {
    next();
  }
});



export default router;

